<template>
  <b-overlay :show="loading">
    <TraysFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <br>
    <MassiveActions
      v-model="selectAll"
      @select-all="selectAllFlows"
      @massive-process="massiveProcess"
      @attempt-process="attemptProcess"
      @cancel="cancelProcess"
      :selected-flows="selectedFlows"
      :process="process"
    />
    <FilesHeader />
    <div class="force-render" :key="forceRender">
      <FileRowMassive
        :key="file.aprobacionId"
        v-for="file in massiveTrays"
        :file="file"
        :process="process"
        :blockedProcess="blockedProcess"
        @select-flow="selectFlow"
        @unselect-flow="unSelectFlow"
      />
    </div>
    <b-modal
      title="Oficinas a las que perteneces"
      ref="assign"
      hide-footer
      no-close-on-backdrop
    >
      <ModalAssign
        :userCompanyGroups="userCompanyGroups"
        @search-flows-office="searchFlowsByOffice"
      />
    </b-modal>
    <b-modal
      :title="titleModal"
      ref="process"
      hide-footer
      no-close-on-backdrop
    >
      <ModalAssignProcess
        v-if="process === 'assign'"
        :selected-flows="selectedFlows"
        :office-selected="groupSelected"
        :process="process"
        @close-modal="closeModal"
      />
      <ModalProcess
        v-if="process !== 'sign' && process !== 'assign'"
        :selected-flows="selectedFlows"
        :process="process"
        @close-modal="closeModal"
      />
      <ModalSignProcess
        v-if="process === 'sign'"
        :selected-flows="selectedFlows"
        :process="process"
        @close-modal="closeModal"
      />
    </b-modal>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FilesHeader from '@/febos/chile/approvals/components/trays/FilesHeader';
import FileRowMassive from '@/febos/chile/approvals/components/trays/FileRowMassive';
import TraysFilters from '@/febos/chile/approvals/components/trays/TraysFilters';
import MassiveActions from '@/febos/chile/approvals/components/massiveProcess/MassiveActions';
import ModalProcess from '@/febos/chile/approvals/components/massiveProcess/ModalProcess';
import ModalSignProcess from '@/febos/chile/approvals/components/massiveProcess/ModalSignProcess';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { clTraysListV2 } from '@/febos/servicios/api/v2.aprobaciones.api';
import { rolTypesCode, stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';
import ModalAssign from '@/febos/chile/approvals/components/massiveProcess/ModalAssign';
import ModalAssignProcess from '@/febos/chile/approvals/components/massiveProcess/ModalAssignProcess';

export default {
  name: 'TraysMassive',
  components: {
    TraysFilters,
    FileRowMassive,
    MassiveActions,
    ModalProcess,
    ModalSignProcess,
    FilesHeader,
    ModalAssignProcess,
    ModalAssign
  },
  mixin: [],
  data() {
    return {
      resendSubject: {},
      process: '',
      loading: false,
      selectedFile: {},
      filters: '',
      view: this.$route.params.view,
      page: Number.parseInt(this.$route.query.page || 1, 10),
      paginate: Number.parseInt(this.$route.query.paginate || 20, 10),
      forceRender: Date.now(),
      selectedFlows: [],
      selectAll: false,
      massiveTrays: [],
      userCompanyGroups: [],
      groupSelected: '',
      loadingCompanyUserGroups: false,
      blockedProcess: JSON.parse(localStorage.getItem('aprobacion_masiva_bloqueada')) || []
    };
  },
  watch: {
    trays() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    async page(page) {
      updateSearchParams({ page });
      await this.fetchTrays();
    },
    error(error) {
      if (error !== '') {
        this.$vs.notify({
          title: 'Oops!',
          text: error,
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
        this.clearErrorMessage();
      }
    },
    selectedFlows(val) {
      if (!val.length) {
        this.process = '';
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'error',
      'trays'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    titleModal() {
      return this.process === 'sign' ? 'Firmar documentos' : 'Procesar documentos';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'listTrays',
      'clearErrorMessage',
      'selectFileState',
      'fetchDocumentTypeReferences'
    ]),
    ...mapActions('Empresas', [
      'getUserSigns'
    ]),
    selectAllFlows() {
      this.massiveTrays = this.massiveTrays.map((flow) => {
        const flowSelected = {
          ...flow,
          selected: this.selectAll
        };
        if (this.selectAll) {
          this.selectedFlows.push(flowSelected);
        } else {
          this.selectedFlows = [];
        }
        return flowSelected;
      });
    },
    selectFlow(file) {
      this.selectedFlows.push(file);
    },
    unSelectFlow(file) {
      this.selectedFlows = this.selectedFlows
        .filter((flow) => (flow !== file.idAprobacion));
    },
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.idAprobacion);
    },
    cancelProcess() {
      this.process = '';
      this.selectedFlows = [];
      this.fetchTrays();
    },
    assignFlows() {
      console.log('asignando expedientes a ', this.resendSubject);
    },
    searchFlowsByOffice(officeId) {
      this.groupSelected = officeId;
      this.$refs.assign.hide();
      this.fetchTrays();
    },
    async fetchUserCompanyGroups() {
      this.userCompanyGroups = [];
      this.loadingCompanyUserGroups = true;
      const response = await ioCompanyGroups(
        {
          empresaId: this.company.id,
          filtros: `usuarioId:${this.currentUser.id}`
        }
      );
      this.userCompanyGroups = response.data.grupos
        .filter((group) => group.esOficina === 'Y' && group.esLider === 'Y')
        .map((office) => ({
          id: office.id,
          label: office.nombre,
          value: office.id
        }));
      this.loadingCompanyUserGroups = false;
    },
    massiveProcess(process) {
      this.process = process;
      if (process === 'assign') {
        this.fetchUserCompanyGroups();
        this.$refs.assign.show();
        return;
      }
      this.fetchTrays();
    },
    attemptProcess() {
      this.$refs.process.show();
    },
    verifyBlockedFlows() {
      const totalMinutes = 5;
      const now = this.$moment();
      // eslint-disable-next-line array-callback-return,consistent-return
      this.blockedProcess = this.blockedProcess.filter((blockedFlow) => {
        const dateFlow = this.$moment(blockedFlow.date);
        const minutes = now.diff(this.$moment(dateFlow), 'minutes');
        if (minutes <= totalMinutes) {
          return blockedFlow;
        }
      });
      localStorage.setItem('aprobacion_masiva_bloqueada', JSON.stringify(this.blockedProcess));
    },
    markBlockedFlows() {
      this.blockedProcess = this.selectedFlows
        .filter((flow) => flow.selected)
        .map((blockedFlow) => ({
          idAprobacion: blockedFlow.idAprobacion,
          date: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          blocked: true
        }));
      localStorage.setItem('aprobacion_masiva_bloqueada',
        JSON.stringify(JSON.stringify(this.blockedProcess)));
    },
    closeModal() {
      this.process = '';
      this.markBlockedFlows();
      this.$refs.process.hide();
      this.selectedFlows = [];
      this.fetchTrays();
    },
    async fetchTrays() {
      this.loading = true;
      const query = {
        filtros: mergeFilters(this.filters, this.$route.query.filters),
        pagina: this.page,
        orden: '-fechaCreacion',
        elementosPorPagina: this.paginate
      };
      if (this.process) {
        let rolType = '';
        let stepType = '';
        switch (this.process) {
          case 'sign':
            rolType = rolTypesCode.firmante;
            query.filtros = query.filtros.concat(`|paso_aprobacionesTipoRolId:${rolType}`);
            break;
          case 'approve':
          case 'reject':
            rolType = rolTypesCode.aprobador;
            query.filtros = query.filtros.concat(`|paso_aprobacionesTipoRolId:${rolType}`);
            break;
          case 'assign':
            stepType = stepTypesCode.oficina;
            query.filtros = query.filtros
              .concat(`|paso_aprobacionesTipoPasoId:${stepType}|oficinaId:${this.groupSelected}`)
              .replace('bandejaTipo:entrada', 'bandejaTipo:oficina')
              .replace('|masiva:Y', '');
            break;
          default:
            console.log('no tiene');
            break;
        }
      }

      const { data } = await clTraysListV2(query);
      this.massiveTrays = data.aprobaciones;
      this.loading = false;
      this.verifyBlockedFlows();
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchTrays();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    }
  },
  created() {
    this.getUserSigns(this.company.iut);
    this.selectFileState('');
    this.fetchDocumentTypeReferences();
    this.selectedFlows = [];
    this.blockedProcess = JSON.parse(localStorage.getItem('aprobacion_masiva_bloqueada')) || [];
    this.process = '';
    this.verifyBlockedFlows();
  },
  mounted() {
    this.fetchTrays();
  }
};
</script>
